import Layout from "../../components/Layout";
import { Helmet } from "react-helmet-async";
import {
  FiBarChart2,
  FiPieChart,
  FiActivity,
  FiClock,
  FiTrendingUp,
  FiDatabase,
  FiEye,
  FiUsers,
  FiSettings,
} from "react-icons/fi";

const ModuleBIReporting = () => {
  const trackCTA = () => {
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "click", {
        event_category: "CTA",
        event_label: "Sign Up - BI Page",
      });
    }
  };

  return (
    <Layout>
      <Helmet>
        <title>BI & Reporting | RedERP</title>
        <meta
          name="description"
          content="Make informed decisions with RedERP’s BI and Reporting module. Get real-time dashboards, visual analytics, and performance insights tailored to your business."
        />
      </Helmet>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[rgb(84,13,14)] to-black text-white">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-10 relative">
          {/* Text */}
          <div className="flex-1 text-left mt-16">
            <h1 className="text-4xl font-bold mb-4">Dashboards & BI Reporting</h1>
            <p className="mb-6 text-sm sm:text-base">
              Uncover key insights, track KPIs, and visualize your business performance in real-time — all in one place.
            </p>
            <a
              href="https://app.rederp.pro/sign-up"
              target="_blank"
              rel="noopener noreferrer"
              onClick={trackCTA}
              className="inline-block bg-white text-primary font-semibold px-6 py-3 rounded-full hover:bg-gray-100"
            >
              Get Started Now
            </a>
          </div>

          {/* Image */}
          <div className="flex-1 hidden md:flex justify-end mt-12 mb-0">
            <img
              src="/assets/images/bi1.png"
              alt="BI and Dashboard Illustration"
              className="w-[420px] lg:w-[420px] xl:w-[420px] h-[310px] object-contain"
            />
          </div>
        </div>
      </section>

      {/* Feature List */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 text-left">
          {[
            {
              icon: <FiBarChart2 size={24} />,
              title: "Custom Dashboards",
              desc: "Create personalized dashboards with widgets for sales, finance, HR, and more.",
            },
            {
              icon: <FiPieChart size={24} />,
              title: "Interactive Charts",
              desc: "Drill down into pie charts, bar graphs, funnels, and heatmaps with one click.",
            },
            {
              icon: <FiClock size={24} />,
              title: "Real-Time Updates",
              desc: "View the latest metrics without delays — powered by live data sync.",
            },
            {
              icon: <FiTrendingUp size={24} />,
              title: "KPI Monitoring",
              desc: "Track key performance indicators across modules and benchmark performance.",
            },
            {
              icon: <FiActivity size={24} />,
              title: "Trend & Forecast Analytics",
              desc: "Identify trends and growth patterns to anticipate business needs.",
            },
            {
              icon: <FiDatabase size={24} />,
              title: "Data Export & Integration",
              desc: "Export reports to Excel, PDF, or integrate with external BI tools via API.",
            },
            {
              icon: <FiEye size={24} />,
              title: "User Role Visibility",
              desc: "Define who can see which reports with advanced user permissions.",
            },
            {
              icon: <FiUsers size={24} />,
              title: "Team Performance Dashboards",
              desc: "Evaluate individual and team outputs across time, projects, or sales funnels.",
            },
            {
              icon: <FiSettings size={24} />,
              title: "Report Builder",
              desc: "Customize layouts, group data, and apply filters to generate dynamic reports.",
            },
          ].map((item, i) => (
            <div
              key={i}
              className="p-6 bg-gray-50 border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-all"
            >
              <div className="flex items-center gap-3 text-primary mb-3">
                {item.icon}
                <h3 className="font-bold">{item.title}</h3>
              </div>
              <p className="text-sm text-gray-600">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 bg-gradient-to-br from-[rgb(84,13,14)] to-black text-white text-center">
        <div className="max-w-xl mx-auto px-6">
          <h3 className="text-3xl font-bold mb-4">Gain Business Clarity with RedERP BI</h3>
          <p className="mb-6">Start your 7-day free trial. No credit card required.</p>
          <a
            href="https://app.rederp.pro/sign-up"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-white text-primary font-semibold px-6 py-3 rounded-full hover:bg-gray-100"
          >
            Try BI & Reporting Now
          </a>
        </div>
      </section>
    </Layout>
  );
};

export default ModuleBIReporting;
